import type { FieldState, VisibilityConfig } from '@/types/FieldConfig'

export interface StateOption {
  value: FieldState;
  /** Untranslated, so the caller decides where the string is rendered. */
  label: string;
  disabled?: boolean;
}

export const stateLabels: Record<FieldState, string> = {
  hidden: 'Hidden',
  optional: 'Optional',
  required: 'Required',
}

/** How loudly a place asks for the field, not whether the setting is good. */
export const stateVariants: Record<FieldState, 'muted' | 'neutral' | 'accent'> = {
  hidden: 'muted',
  optional: 'neutral',
  required: 'accent',
}

/**
 * A locked choice stays visible rather than disappearing, so the reason it cannot
 * be made is legible instead of the option simply being absent.
 */
export const stateOptions = (locked?: VisibilityConfig): StateOption[] => [
  { value: 'hidden', label: stateLabels.hidden, disabled: locked?.display },
  { value: 'optional', label: stateLabels.optional, disabled: locked?.required },
  { value: 'required', label: stateLabels.required, disabled: locked?.required },
]

/** A place whose every choice is locked cannot be edited at all. */
export const isLocked = (locked?: VisibilityConfig): boolean =>
  stateOptions(locked).every(option => option.disabled)
